<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            dark
            flat
          >
            <v-toolbar-title>Logga in</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-tooltip bottom>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="E-post"
                name="email"
                type="text"
                v-model="email"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Lösenord"
                name="password"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn  text color="primary" @click="forgotPasswordAction">Glömt lösenordet?</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="validateLogin">Logga in</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import SweetAlert from '@/services/SweetAlert'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },

  created () {
    if (localStorage.getItem('token')) {
      this.refreshAction()
        .then(() => {
          this.$router.push('/')
        })
    }
  },

  methods: {
    ...mapActions(['loginAction']),
    ...mapActions(['refreshAction']),
    resetForm () {
      this.email = ''
      this.password = ''
    },
    // Will call the API and return the result
    validateLogin () {
      const userDetails = {
        email: this.email,
        password: this.password
      }
      this.loginAction(userDetails)
        .then(() => {
          this.$router.push('/home')
          this.resetForm()
          SweetAlert.successfulLogin()
        })
        .catch(() => {
          this.$router.push('/login')
          this.resetForm()
          SweetAlert.failureLogin()
        })
    },

    forgotPasswordAction () {
      this.$router.push('/recovery-link')
    }
  }
}
</script>
